import { createFretboardMarkers } from '@fretgenius/ui';

// Create the FretboardMarkers component using the factory from @fretgenius/ui
export const FretboardMarkers = createFretboardMarkers({
  G: (props) => <g {...props} />,
  Circle: (props) => <circle {...props} />,
});
